(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('BuscadorController', BuscadorController);

    /* @ngInject */
    function BuscadorController(Edicion, Exportar, ediciones, $state, $stateParams, ModalService, JsonUtils) {
        var vm = this;
        var todasSeleccionadas = false;

        vm.filter = $stateParams.filter;
        vm.pagina = $stateParams.page;

        vm.buscar = function (pageChange) {
            if (!vm.filter.sortProperty) {
                vm.filter.sortProperty = 'autor';
            }

            // Se utiliza una variable para que la página activa sólo se modifique cuando se hayan cargado los datos.
            var pagina = vm.pagina;
            if (!pageChange) {
                pagina = 1;
            }
            vm.filter.page = pagina - 1;

            Edicion.publicSearch(vm.filter).$promise.then(function (data) {
                data.content.forEach(function (element) {
                    element.titulo = corregirTitulo(element.titulo);
                });
                angular.extend(ediciones, data);

                vm.pagina = pagina;
                $state.go(".", {filter: vm.filter, page: vm.pagina}, {notify: false});
            });
        };

        vm.cambiarCriterioOrdenacion = function (sortProperty) {
            vm.filter.sortProperty = sortProperty;
            vm.buscar(false);
        };

        //seleccionar todos los elementos de una pagina a exportar -> si ya están marcados todos, se desmarca
        vm.seleccionarTodas = function () {
            if (!todasSeleccionadas) {
                ediciones.content.forEach(function (element) {
                    element.seleccionada = true;
                    todasSeleccionadas = true;
                });
            } else {
                ediciones.content.forEach(function (element) {
                    element.seleccionada = false;
                    todasSeleccionadas = false;
                });
            }
        };

        vm.exportarAPDF = function () {
            var edicionesAExportar = [];
            ediciones.content.forEach(function (element) {
                if (element.seleccionada) {
                    edicionesAExportar.push(element.id);
                }
            });
            var filterPdf = angular.copy(vm.filter);
            filterPdf.edicionesAExportar = edicionesAExportar;
            filterPdf.formatoExportacion = 'PDF';
            return Exportar.exportar(filterPdf);
        };

        //Enviar por email: abrir ventana modal
        vm.enviarEmail = function () {
            var edicionesAExportar = [];
            ediciones.content.forEach(function (element) {
                if (element.seleccionada) {
                    edicionesAExportar.push(element.id);
                }
            });
            var filterPdf = angular.copy(vm.filter);
            filterPdf.edicionesAExportar = edicionesAExportar;
            filterPdf.formatoExportacion = 'EMAIL';

            ModalService.open({
                templateUrl: 'app/public/edicion/email/email.form.modal.html',
                controller: 'EmailFormController',
                controllerAs: 'ctrl',
                resolve: {
                    /* @ngInject */
                    item: function () {
                        return filterPdf;
                    }
                }
            }).result.then(function (data) {
            });
        };



        // Abrir ventana modal para ver las instrucciones para la búsqueda
        vm.openInstructions = function () {
            ModalService.open({
                templateUrl: 'app/public/edicion/ayuda/ayuda.modal.html',
                controller: 'AyudaController',
                controllerAs: 'ctrl',
                size: 'lg'
            });
        };

        // Limpiar formulario y hacer búsqueda
        vm.clear = function () {
            var filterCopy = angular.copy(vm.filter);
            JsonUtils.cleanJson(vm.filter);
            vm.filter.size = filterCopy.size;
            vm.buscar(false);
        };


        vm.cambiarBuscador = function (avanzado) {
            // vm.clear();
            // Se ponen a null los campos que no tiene el otro buscador y se mantienen el resto.
            if (avanzado) {
                vm.filter.general = null;
                vm.filter.persona = null;
                vm.filter.anoEdicion = null;

                $state.go("buscador/avanzado", {filter: vm.filter});
            } else {
                vm.filter.tituloRelacion = null;
                vm.filter.autor = null;
                vm.filter.anonima = null;
                vm.filter.lugarAcontecimiento = null;
                vm.filter.bdrs = null;
                vm.filter.anoInicioAcontecimiento = null;
                vm.filter.anoFinAcontecimiento = null;
                vm.filter.sinAnoAcontecimiento = null;
                vm.filter.modalidadDiscurso = null;
                vm.filter.tamano= null;
                vm.filter.impresor = null;
                vm.filter.sinImpresor = null;
                vm.filter.editor = null;
                vm.filter.traductor = null;
                vm.filter.otrosRoles = null;
                vm.filter.idioma = null;
                vm.filter.tipologia = null;
                vm.filter.subgenero = null;
                vm.filter.biblioteca = null;
                vm.filter.pais = null;
                vm.filter.epiteto = null;
                vm.filter.variasEdiciones = null;
                vm.filter.tieneIlustraciones = null;


                $state.go("buscador/basico", {filter: vm.filter});
            }
        };

        function corregirTitulo(titulo) {
            if (!titulo.endsWith(".")) {
                titulo = titulo.concat(".");
            }
            return titulo;
        }

        // Hacemos una búsqueda inicial
        vm.buscar(true);
    }
})
(angular);
